import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import GoalCommentPage from './GoalCommentPage';

const GoalCommentPageWrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { goalId } = params;

  console.log('GoalCommentPageWrapper - goalId:', goalId);

  return (
    <GoalCommentPage 
      navigate={navigate}
      location={location}
      // goalId={location.state?.goalId}
      goalId={goalId}
    />
  );
};

export default GoalCommentPageWrapper;
